import { Container } from 'pixi.js';
import { RaceEventRankFlagLayout } from '../../../../../layouts/raceEvent/RaceEventRankFlagLayout';
import { applyLayoutState } from '../../../../libs/layouts/populateLayouts/applyLayoutState';
import type { RaceTrackProgress } from '../RaceEventPopupTrackView';

export class RaceRankFlagView extends Container {
  private layout: RaceEventRankFlagLayout | null = null;

  private currentRank = 0;

  private currentProgress = 0;

  constructor(raceTrackProgress: RaceTrackProgress) {
    super();
    this.currentRank = raceTrackProgress.rank;
    this.currentProgress = raceTrackProgress.normProgress;

    if (this.currentRank <= 3 && this.currentProgress > 0) {
      this.layout = this.createLayout(this.currentRank);
    }
  }

  private createLayout(rank: number): RaceEventRankFlagLayout {
    const layout = new RaceEventRankFlagLayout();
    if (rank === 2) applyLayoutState(layout, '2nd');
    if (rank === 3) applyLayoutState(layout, '3rd');
    layout.root.props({
      parent: this,
    });
    return layout;
  }

  public async animateChange({ rank, normProgress }: RaceTrackProgress): Promise<void> {
    if (normProgress === 0) return;

    const firstVisibleChange = this.currentProgress === 0 && normProgress > 0;
    const shouldAnimate = firstVisibleChange || this.currentRank !== rank;

    this.currentRank = rank;
    this.currentProgress = normProgress;

    if (!shouldAnimate) return;

    await (this.layout?.root?.tweenTo({ scaleXY: 0 }, 250, 'cubicIn', true).asyncOnComplete() ?? this.wait(250));
    this.layout?.root.destroy({ children: true });
    this.layout = null;

    if (rank <= 3) {
      this.layout = this.createLayout(rank);
      this.layout.root.props({ scaleXY: 0 });
      await this.layout.root.tweenTo({ scaleXY: 1 }, 250, 'appear1', true).asyncOnComplete();
    }
  }
}
